import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../../types/HtmlProps';

export function AccordionElement({ children, ...divProps }: PropsWithChildren<DivProps>) {
  return (
    <div {...divProps} className="accordion__item">
      {children}
    </div>
  );
}
